<template>
  <div class="customer-detail">
    <div class="customer-header pt-0">
      <slot name="header"></slot>

      <div class="text-xs-center">
        <v-avatar size="100">
          <v-img
            :lazy-src="user.profile_pic"
            :src="user.profile_pic"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-img>
        </v-avatar>
        <div class="text-xs-center mt-2" style="color: white">
          {{ user.first_name ? user.first_name : '' }} {{ user.last_name ? user.last_name : '' }}
        </div>
        <div class="mb-4 text-xs-center">
          <v-btn
            :href="'https://business.facebook.com' + user.inboxurl"
            target="_blank"
            small
            depressed
            round
            color="#3b5998"
            dark
            v-if="user.app == 'facebook' && user.inboxurl"
          >
            <i class="fab fa-facebook-square mr-1"></i>
            {{ $t('View inbox') }}
          </v-btn>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Channel') }}</label>
          <p>
            <span style="color: #3b5998" v-if="user.app == 'facebook'">
              <i class="fab fa-facebook-square"></i> Facebook
            </span>
            <span style="color: #00c300" v-else-if="user.app == 'line'">
              <i class="fab fa-line"></i> Line
            </span>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('gender') }}</label>
          <p>{{ $t(user.gender) }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Locale') }}</label>
          <p>
            <template v-if="userLocale">
              <flag :iso="userLocale.icon" />
              {{ userLocale.title }}
            </template>
            <template v-else
              >-</template
            >
          </p>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption">
            {{ $t('Status') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <div>
            <p>
              <edit-customer-value
                v-model="user['status']"
                :userid="user.id"
                :placeholder="$t('Status')"
                @onEdit="onEditStatus"
              >
                <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
              </edit-customer-value>
            </p>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Register Date') }}</label>
          <p>
            {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Last Active Date') }}</label>
          <p>{{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}</p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Email') }}</label>
          <p>
            <edit-customer-value
              v-model="user['email']"
              :userid="user.id"
              :placeholder="$t('Email')"
              @onEdit="onEditEmail"
            >
              <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('phone no.') }}</label>
          <p>
            <edit-customer-value
              v-model="user['phoneno']"
              :userid="user.id"
              :placeholder="$t('phone no.')"
              @onEdit="onEditPhone"
            >
              <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Context') }}</label>
          <p>
            <edit-customer-value
              v-model="user['context']"
              :userid="user.id"
              :placeholder="$t('Context')"
              @onEdit="onEditContext"
            >
              <customer-item-value :value="user['context']">{{ user.context }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Line ID') }}</label>
          <p>
            <edit-customer-value
              v-model="user['lineid']"
              :userid="user.id"
              :placeholder="$t('Line ID')"
              @onEdit="onEditLineId"
            >
              <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('School') }}</label>
          <p>
            <edit-customer-school
              v-model="user['school']"
              :userid="user.id"
              :placeholder="$t('School')"
              @onEdit="onEditSchool"
            >
              <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
            </edit-customer-school>
          </p>
        </v-flex>

        <v-flex v-if="isBU" xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Province') }}</label>
          <p>
            <edit-customer-value
              v-model="user['province']"
              :userid="user.id"
              :placeholder="$t('Province')"
              @onEdit="onEditProvince"
            >
              <customer-item-value :value="user['province']">{{
                user.province
              }}</customer-item-value>
            </edit-customer-value>
          </p>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>
          {{ $t('Tag') }}
          <v-premium-lock :inline="true"></v-premium-lock>
        </label>

        <a
          href="javascript:void(0);"
          v-if="$store.getters.getPackage == 'premium' && !isEditTag && !isCoachlab"
          @click="isEditTag = true"
        >
          <i class="fa fa-pencil-alt middle"></i>
        </a>
      </div>
      <div class="pl-3 pr-3 pt-2 pb-2">
        <template v-if="!isEditTag">
          <div class="left-align" v-if="tags.length == 0">{{ $t('No tag') }}</div>
          <ul class="tags">
            <li class="tag" v-for="(tag, index) in tags" :key="'usertag_' + index">
              <specialtext :text="tag"></specialtext>
            </li>
          </ul>
        </template>
        <template v-else>
          <tags
            v-model="usertag"
            :tags="usertags"
            @tags-changed="addUserTags"
            @before-adding-tag="checkUserTags"
            style="margin-bottom: 5px;"
            :btnText="$t('Add tag')"
          ></tags>

          <div class="text-xs-center" style="margin-top: 15px;">
            <v-btn outline color="grey" small @click="cancelEditTag">{{ $t('cancel') }}</v-btn>
            <v-btn depressed color="primary" small @click="saveEditTag">{{ $t('Save') }}</v-btn>
          </div>
        </template>
      </div>

      <v-divider></v-divider>

      <div class="pl-3 pr-3 pt-2 pb-2">
        <label class="caption" for>{{ $t('Message Sent') }}</label>
        <div style="position: relative" margin-top="25">
          <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup>
          <div
            style="overflow-y: auto;max-height: 300px;padding: 5px; background: #f7f7f7; border: 1px solid #eee;border-radius: 5px;"
          >
            <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
              <div
                v-for="(intent, index) in 10"
                :key="'intent_' + index"
                style="padding: 10px; margin: 5px 0; border: 1px solid #eee;background: white"
              >
                <div
                  style="height: 15px;position: relative;top: 3px;display: inline-block; width: 100%; max-width: 100px;background-color: #eee"
                ></div>
              </div>
            </template>
            <template v-else>
              <template v-if="filterIntent.length > 0">
                <div
                  v-for="(intent, index) in filterIntent"
                  :key="'intent_' + index"
                  style="padding: 10px; margin: 5px 0; border: 1px solid #eee;background: white"
                >
                  <template v-if="$store.getters.getPackage == 'premium' && !isCoachlab">
                    <template v-if="intent[0] === '{default}'">{{
                      $t('Default Conversation')
                    }}</template>
                    <template v-else-if="intent[0] === '{welcome}'">{{
                      $t('Welcome Message')
                    }}</template>
                    <template v-else-if="intent[0] === '{default_comment_to_inbox}'">{{
                      $t('More Comment to Inbox')
                    }}</template>
                    <template v-else-if="intent[0] == null">{{ $t('Other') }}</template>
                    <template v-else>{{ intent[0] }}</template>
                    ({{ intent[1] | numberFormat }})
                  </template>
                </div>
              </template>
              <template v-else>
                <div class="text-center">{{ $t('No message sent') }}</div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import EditCustomerSchool from './EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
export default {
  props: {
    value: {
      default: undefined
    }
  },
  data: function() {
    return {
      loading: true,
      user: {},
      isEditTag: false,
      usertag: '',
      profile_pic: ''
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    EditCustomerSchool,
    specialtext,
    Tags
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function() {
      var vm = this
      return vm.user.intentlist.sort(function(a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function() {
      var vm = this
      return config.locale.find(function(locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function() {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    }
  },
  mounted: function() {
    this.getuserDetail()
    // this.user = this.value
    // this.cached_tag = this.user.tags
  },
  methods: {
    getuserDetail() {
      let vm = this
      let data = { pageid: vm.selectedBot.pageid, userid: vm.value }
      api.getuserCustomer(data, function(error, response) {
        if (error) console.error(error)
        vm.user = response.data[0]
        vm.loading = false
      })
    },
    onEditContext(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        context: payload.customer_value
      }
      api.saveUserContext(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    saveEditTag: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags
      }
      api.saveUserTags(data, function(error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function() {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function() {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return moment(date).format(format)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value
      }
      api.saveUserStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditLineId: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        lineid: payload.customer_value
      }
      api.saveUserLineId(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditSchool: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        school: payload.customer_value
      }
      api.saveUserSchool(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditProvince: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        province: payload.customer_value
      }
      api.saveUserProvince(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value
      }
      api.saveUserEmail(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value
      }
      api.saveUserPhoneno(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    // value: function() {
    //   this.user = this.value
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/CustomerDetail.vue